"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import GTMEventLink from "~/components/ui/GTMEventLink";
import { sendFacebookEvent } from "~/lib/facebookEvents/FacebookEventsClient";
import { useUnauthorizedEventService } from "~/services/api/services/event";
import { APP_ROUTES } from "~/constants/appRoutes";
import { QUIZ_ROUTES, QuizRoute } from "~/constants/quizRoutes";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import { useQuizLink } from "~/components/features/quiz";

const GetStartedLink = () => {
    const pathname = usePathname();
    const [quizRoute, setQuizRoute] = useState<QuizRoute>(QUIZ_ROUTES.HORMONE_IMBALANCE);
    const sendBigQueryEvent = useUnauthorizedEventService();

    useEffect(() => {
        if (pathname.includes(APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM)) {
            setQuizRoute(QUIZ_ROUTES.ANTI_AGING_FACE_CREAM);
        } else if (pathname.includes(APP_ROUTES.LIBIDA_LP)) {
            setQuizRoute(QUIZ_ROUTES.LIBIDA);
        } else if (pathname.includes("/p/longevity/nad")) {
            setQuizRoute(QUIZ_ROUTES.NAD);
        } else if (pathname.includes(APP_ROUTES.TREATMENT_POSTPARTUM)) {
            setQuizRoute(QUIZ_ROUTES.POSTPARTUM);
        } else {
            setQuizRoute(QUIZ_ROUTES.HORMONE_IMBALANCE);
        }
    }, [pathname]);

    const { href } = useQuizLink(quizRoute);

    return (
        <GTMEventLink
            href={href}
            className="inline-flex items-center justify-center h-[32px] lg:h-[40px] cursor-pointer rounded-full font-suisseBP text-[12px] leading-[20px] font-medium tracking-[1.12px] bg-heroBlue text-white px-3 lg:px-6 pt-[2px] uppercase whitespace-nowrap"
            gtmEventData={{
                event: "user_interaction",
                value: {
                    event_name: GTM_EVENT_NAMES.MAIN_NAVIGATION,
                    widget: "sticky_header",
                    meta_data: {
                        click_text: "Get started",
                    },
                },
            }}
            handleClick={() => {
                sendFacebookEvent(sendBigQueryEvent, {
                    event_name: "GetStarted",
                });
            }}
        >
            Get started
        </GTMEventLink>
    );
};

export default GetStartedLink;
